import React from 'react';
import styled from 'styled-components';

const EmptyCard: React.FC = () => {
	return <EmptyText>You don't have any additional cards yet.</EmptyText>;
};

const EmptyText = styled.p`
	color: #575757;
	width: 100%;
	font-weight: 600;
	font-size: 20px;
`;

export default EmptyCard;
